import { ElementType } from 'react';

import styles from './CaretButton.module.scss';

const directions = {
  up: -90,
  right: 0,
  down: 90,
  left: 180,
};

type Props = {
  dir?: keyof typeof directions;
  as?: ElementType;
} & React.HTMLProps<HTMLElement>;

const CaretButton: React.FC<Props> = ({ children, as = 'button', dir = 'right', ...props }) => {
  const Component = as || 'button';
  return (
    <Component className={styles.CaretButton} {...props}>
      {children && children}
      <div className={styles['_icon']} style={{ '--direction': directions[dir] + 'deg' }}>
        <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 1L11 7L5 13" stroke="black" />
        </svg>
      </div>
    </Component>
  );
};

export default CaretButton;
